import segment from './segment';
import sentry from './sentry';

export default {
  segment,
  sentry,
};
